import React from 'react';
import {Col,ListGroup} from 'react-bootstrap';
import {
    Link
  } from "react-router-dom";

export default function(){
    return (
      <Col xs={2} data-testid="nav">
        <ListGroup style={{paddingTop:10}}>
          <ListGroup.Item>
            <Link to="/">Help</Link>
          </ListGroup.Item>
          <ListGroup.Item>
            <Link to="/message/new">New Message</Link>
          </ListGroup.Item>
          <ListGroup.Item>
            <Link to="/contacts">Manage Contacts</Link>
          </ListGroup.Item>
          <ListGroup.Item>
            <Link to="/groups">Manage Groups</Link>
          </ListGroup.Item>
          <ListGroup.Item>
            <Link to="/sent">Sent Messages</Link>
          </ListGroup.Item>
          <ListGroup.Item>
            <Link to="/logout">Logout</Link>
          </ListGroup.Item>
        </ListGroup>
      </Col>
    )
  }